import * as React from "react";
import {inject, observer} from "mobx-react";
import {Router as Router} from "react-router-dom";
import Master from "@templates/master";
import {Grid} from "@components/Grid/Grid"
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'


@inject("store")
@observer
export default class History extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {

        const containerClass = this.props.navigation.pageContent.Properties.layout ? "history-container-" + this.props.navigation.pageContent.Properties.layout : "";

        return (
            <Master {...this.props}>
                <div className={containerClass}>
                    <div className={"container-fluid"}>
                        <Grid {...this.props} model={this.props.navigation.pageContent.Properties.historyGrid}/>
                    </div>
                </div>
            </Master>
        );
    }
}
